import { render, staticRenderFns } from "./JudgeLink.vue?vue&type=template&id=b93022d6&scoped=true&"
import script from "./JudgeLink.vue?vue&type=script&lang=js&"
export * from "./JudgeLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b93022d6",
  null
  
)

export default component.exports